'use client'
import React from 'react'
import Icon, { Icons } from '@crystal-eyes/components/elements/Icon/Icon'
import { DatumTags, DatumType, PlaybookTypes } from '@crystal-eyes/types'
import useUserIdentity from '@crystal-eyes/hooks/user/useUserIdentity'
import usePersonalInfo from '@crystal-eyes/hooks/profiles/usePersonalInfo'
import useRelationshipDatums from '@crystal-eyes/hooks/profiles/useRelationshipDatums'
import { getCreatePlaybookRoute } from '@dashboard/lib/playbooks/profile'
import useProfileId from '@crystal-eyes/hooks/profiles/useProfileId'
import usePlaybookTemplates from '@crystal-eyes/hooks/playbooks/usePlaybookTemplates'
import ExternalLink from '@crystal-eyes/components/elements/Button/ExternalLink'
import { useRouter } from 'next/navigation'

interface Identity {
  id: string
}

export default function RelationshipDatum({
  cta,
  identity,
  tags,
  type,
  playbookType,
}: {
  cta?: string
  identity?: Identity
  tags: DatumTags[]
  type: DatumType
  playbookType?: PlaybookTypes
}) {
  const router = useRouter()
  const { data: personalInfo } = usePersonalInfo({ identity })
  const { data: userIdentity } = useUserIdentity()
  const { data: userPersonalInfo } = usePersonalInfo({ identity })
  const { data: relationshipDatum } = useRelationshipDatums({
    identity,
    withIdentity: userIdentity,
    tags,
    type,
    limit: 1,
  })

  const { data: playbooks } = usePlaybookTemplates()

  const playbook = playbooks?.find(
    playbook =>
      playbook.permalink == playbookType || playbook.name == playbookType,
  )

  const isIndividualPlaybook = playbook?.type === 'individual'
  const templateId = playbook?.id

  const { data: profileId } = useProfileId({ identity: identity! })
  const { data: authUserId } = useProfileId({ identity: userIdentity! })

  if (!personalInfo || !userPersonalInfo || !relationshipDatum) return null

  if (
    !personalInfo ||
    !userPersonalInfo ||
    !relationshipDatum ||
    relationshipDatum.length === 0
  )
    return null

  const createPlaybook = () => {
    const reqUrl = getCreatePlaybookRoute({
      templateId,
      profileId,
      authUserId,
      isIndividualPlaybook,
    })
    console.log(reqUrl)
    router.push(reqUrl)
  }

  return (
    <div className="relationship-info">
      <div className={`CE Parented disc-color disc-border label`}>
        {type === DatumType.Phrase && (
          <>
            <Icon icon={Icons.People} />
            <span>Relationship</span>
          </>
        )}

        {type === DatumType.Overview && (
          <>
            <Icon icon={Icons.MagnifyingGlass} />
            <span>Summary</span>
          </>
        )}
      </div>

      <div className={`relationship-content CE Parented disc-border`}>
        <p>{relationshipDatum[0].text}</p>

        {cta && (
          <div className="cta">
            <ExternalLink onClick={() => createPlaybook()}>{cta}</ExternalLink>
          </div>
        )}
      </div>
    </div>
  )
}
